import "@mdi/font/css/materialdesignicons.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import VueAxios from "./axios";
import ViaCep from "vue-viacep";
import pt from "vuetify/es5/locale/pt";

import VueCurrencyInput from "vue-currency-input";

// register directive v-money and component <money>
const pluginOptions = {
  globalOptions: {
    currency: "BRL",
    autoDecimalMode: true,
  },
};
Vue.use(VueCurrencyInput, pluginOptions);
//import axios from 'axios'

Vue.use(Vuetify);

Vue.use(ViaCep);
export default new Vuetify({
  lang: {
    locales: {
      pt,
    },
    current: "pt",
  },
  icons: {
    iconfont: "md", // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: "#B94F4F",//"#660000",
        botao_login:"#E06616",
        topo: "#511D1D",
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#b71c1c",
        botao_sucesso: "#66BB6A",
        sucesso: "#66BB6A",
        bota_error: "#E65100",
        topPreparacao: "#FFBF00",
        topPedidos: "#BC1F28",
        topEnviados: "#01B403",
        btBlue: "#03A6FF",
        delete: "#FF4949",
        loginLeft: "#F1F1E4",
        print: "#f39c12",
      },
    },
  },
});
